import Collapse from './Collapse';
export { CollapseProps, PanelProps } from './Collapse';
export { CollapsePanelProps, CollapsibleType } from './CollapsePanel';
export default Collapse;
